import { Component, OnInit, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../security/authentication.service';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  template: '<div class="container py-5"><p>Completing sign in...</p></div>',
})
export class AuthCallbackComponent implements OnInit {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly location = inject(Location);
  private readonly router = inject(Router);

  ngOnInit(): void {
    void this.completeLogin();
  }

  private async completeLogin(): Promise<void> {
    this.location.replaceState('/auth/callback');

    try {
      await this.authenticationService.waitForInitialization();
      if (!this.authenticationService.isAuthenticated()) {
        this.authenticationService.removeLocalSession();
        await this.router.navigate(['login']);
        return;
      }
      await this.router.navigateByUrl(this.authenticationService.consumeReturnUrl());
    } catch {
      this.authenticationService.removeLocalSession();
      await this.router.navigate(['login']);
    }
  }
}
